import { useMemo } from 'react';

// Utility to determine if a color is dark (hex only, brown included)
export function isHexColorDark(hex) {
  // Normalize hex (remove leading # if present)
  hex = hex.replace(/^#/, '');

  // Support short hex (#RGB -> #RRGGBB)
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  if (hex.length !== 6) {
    throw new Error('Invalid HEX color format');
  }

  // Convert to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance < 0.6 ? 'dark' : 'light';
}

export function freezeScrollContainer(lock: boolean, selectors: string[]) {
  selectors.forEach((selector) => {
    const container = document.querySelector(selector) as HTMLElement | null;
    if (container) {
      const originalOverflow = container.style.overflow;
      if (lock) {
        container.style.overflow = 'hidden';
        container.setAttribute('data-original-overflow', originalOverflow || 'auto');
      } else {
        const restore = container.getAttribute('data-original-overflow') || 'auto';
        container.style.overflow = restore;
        container.removeAttribute('data-original-overflow');
      }
    }
  });
}

// Permissions for full tags management access
export const REQUIRED_TAG_ACTIONS = [
  'create_tag',
  'view_tags',
  'edit_tag',
  'delete_tag',
  'attach_tag',
  'detach_tag',
];

export type PermissionAction = {
  name: string;
  allowed: boolean;
};

export function useHasFullTagsAccess(actions?: PermissionAction[]): boolean {
  return useMemo(() => {
    if (!actions || actions.length === 0) return false;
    return REQUIRED_TAG_ACTIONS.every((actionName) =>
      actions.some((action) => action.name === actionName && action.allowed)
    );
  }, [actions]);
}
